import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormItem} from '../json-form/json-form-item/FormItem';
import {AutoSizeType} from 'ng-zorro-antd/input/autosize.directive';

@Component({
  selector: 'gn-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GnTextareaComponent),
    multi: true
  }]
})
@GnFormItem('input-textarea')
export class GnTextareaComponent implements ControlValueAccessor {

  private innerValue: string;

  @Input() placeholder = '';
  @Input() autosize: string | boolean | AutoSizeType = true;

  @Input() set value(v: string) {
    if (this.innerValue !== v) {
      this.innerValue = v;
      this.valueChange(this.innerValue);
    }
  }

  get value(): string {
    return this.innerValue;
  }

  valueChange = (value: string) => {
  }

  registerOnChange(fn: any): void {
    this.valueChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

}
